import { array, string } from 'yup'
import { safify } from '../utils/safify'
import { isUrl } from './utils'

export const links = array()
  .of(
    string().test('is-url', 'One or more links are invalid.', (value) => {
      if (!value) return true
      return isUrl(value)
    }),
  )
  .default([])
  .meta({
    label: 'Links to include',
    placeholder: 'Add links to include in the post',
    autoFill: true,
  })
  .transform(safify)
